
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.5 41.84L19.92 3.25c-1.76-1.75-7-1.75-7-1.75s0 5.26 1.75 7l38.57 38.6zM35.7 19a3.72 3.72 0 00-5.26 5.26M37.45 31.32l5.27-5.27M47.1 53.24L8.52 14.65c-1.76-1.75-7-1.75-7-1.75s0 5.26 1.75 7l38.57 38.6zM24.3 30.44A3.72 3.72 0 0019 35.7M26.05 42.72l5.27-5.27","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M28.23 45c-3.94 4.63-5.07 6.81-8.57 10.31A10.56 10.56 0 014.73 40.34c3.51-3.51 5.7-4.64 10.34-8.6M39.25 33.44c-.91.87-1.88 1.83-2.93 2.88s-2.11 2.13-3 3.07M32 14.72c3.72-4.41 4.88-6.57 8.3-10a10.56 10.56 0 1114.97 14.94C51.78 23.15 49.6 24.29 45 28.2M20.94 26.37c.85-.82 1.76-1.71 2.74-2.69s1.95-2 2.8-2.85M49.69 2.46v21.47M10.66 35.64v22.44","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    